<template>
  <div class="tile is-child">
    <article class="message has-box-shadow">
      <div class="message-header">
        <div class="header-title-wrapper">
          <div v-if="displayLoader" class="loader-container">
            <div class="is-loading" v-if="loading"></div>
            <div class="is-not-loading" v-else></div>
          </div>
          {{ title }}
        </div>
        <slot name="header"></slot>
      </div>
      <div class="message-body">
        <slot />
      </div>
      <div v-if="hasFooterSlot" class="message-footer">
        <slot name="footer" class="footer"></slot>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },

    displayLoader: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasFooterSlot () {
      return !!this.$slots['footer']
    }
  },

  name: 'grid-box'
}
</script>

<style lang="scss">
  @import '~@/assets/styles/common/common';

  .message {
    height: 100%;
    display: flex;
    flex-direction: column;

    .message-header {
      font-size: 1.2rem;
      font-family: 'Roboto', 'sans-serif';
      font-weight: 100;
      text-transform: uppercase;
      // line-height: 1;
      height: 3rem;
      // padding: 0 0.5rem 0 1rem;
      padding: 0 0.5rem 0 1rem;
      align-items: center;
      background-color: $onflow-gray;
      flex-direction: row;
      flex-wrap: wrap;
      margin-block-end: 0;
      margin-block-start: 0;

      .header-title-wrapper {
        display: flex;
        white-space: nowrap;

        .loader-container {
          flex: 0 0 2rem;

          .is-loading {
            top: 0;
            @include desktop {
              top: 0.2rem;
            }

            &::after {
              // transform: scale(0.3);
              height: 1.5rem;
              width: 1.5rem;
              left: 0;
              top: 0;
              border-width: 1.5px;
            }
          }
          .is-not-loading {
            position: relative;
            pointer-events: none;
            opacity: 0.9;
            top: 0;

            @include desktop {
              top: 0.2rem;
            }

            &::after {
              border: 1.5px solid $onflow-green;
              border-radius: 290486px;
              content: "";
              display: block;
              position: absolute;
              width: 1.5rem;
              height: 1.5rem;
            }
          }
        }
      }

      p {
        margin: 0 !important;
        margin-bottom: 0 !important;
      }

      @include desktop {
        font-size: 1.5rem;
      }
    }

    .message-body {
      flex: 1;
      padding: 1rem;
      height: calc(100% - 2rem);
      // box-sizing: border-box;

      label.label:first-child {
        margin-top: 0;
      }

      a {
        color: $link !important; // Overriding exceptionally retarded hardcoded css in bulma. Why, you fucking retards? WHY?

        &:hover {
          color: $link-hover !important; // Overriding exceptionally retarded hardcoded css in bulma. Why, you fucking retards? WHY?
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/boxes/GridBox.vue